var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRank4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EBE0FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3629_17041",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 15.5825,
    height: 15.5825,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3629_17041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7823 20.6349L11.8373 16.0738L8.29883 13.006L12.9736 12.6002L14.7915 8.29883L16.6095 12.6002L21.2842 13.006L17.7457 16.0738L18.8008 20.6349L14.7915 18.2164L10.7823 20.6349Z",
    fill: "#6D2ED1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank4);
export default __webpack_public_path__ + "static/media/Rank-4.1c24f0453520ab883925038cf16e23a7.svg";
export { ForwardRef as ReactComponent };